<template>
  <a class="BaseLink" v-bind="$attrs">
    <slot />
  </a>
</template>

<script>
import checkRequiredSlots from '../../utils/checkRequiredSlots'

export default {
  name: 'BaseLink',
  props: {
    size: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'small'].includes(value) || value === 'default'
      },
    },
  },
  created() {
    checkRequiredSlots(this.$slots, ['default'], 'BaseLink')
  },
}
</script>

<style lang="scss">
.BaseLink {
  color: $color-brand-primary;
  text-decoration: underline;
  cursor: pointer;

  &.default {
    @include link-body-1;
  }

  &.small {
    @include link-body-2;
  }

  &,
  * {
    box-sizing: border-box;
  }
}
</style>
